// extracted by mini-css-extract-plugin
export var phone = "_24-0";
export var phoneDragging = "_24-1";